import * as React from 'react';
import {
  useCoursesWithTeacher,
  groupCoursesIeltsForDisplay
} from '../dataMapper';
import { useCoursesGroupData } from 'shared/CourseLanding/data/useCoursesGroupData';
import { CardCoursePopup, CardCourse } from 'shared/CourseLanding/CoursesIelts';
import { Grid } from 'styled-css-grid';
import styled, { css } from 'styled-components';

import { fromScreen } from 'utils/media-query/responsive.util';
import { colorsV2 } from 'style/colors-v2';
import { Typography } from 'components/DesignSystemV2/Typography';
import cl from 'classnames';

const CourseListContainer = styled.div`
  .course-group-list {
    display: grid;
    gap: 24px;

    grid-auto-flow: column;
    overflow-y: hidden;
    overflow-x: auto;
    scroll-snap-type: x mandatory;

    scroll-behavior: smooth;
    -webkit-overflow-scrolling: touch;

    /* Hide scrollbar for Chrome, Safari and Opera */

    &::-webkit-scrollbar {
      display: none;
    }

    /* Hide scrollbar for IE, Edge and Firefox */
    -ms-overflow-style: none; /* IE and Edge */
    scrollbar-width: none; /* Firefox */

    .card-course {
      width: 252px;
      position: relative;
      .rating {
        position: absolute;
        top: 8px;
        right: 8px;
        background: ${colorsV2.yellow10};
        display: flex;
        align-items: center;
        padding: 0 4px;
        border-radius: 4px;
      }

      color: ${colorsV2.black100};

      .card-course-image {
        margin-bottom: 12px;
        img {
          width: 100%;
          border-radius: 8px;
        }
      }

      .card-course-title {
        font-size: 20px;
        font-weight: 600;
        line-height: 28px;
        margin-bottom: 4px;

        a {
          color: ${colorsV2.black100};
          &:hover {
            text-decoration: underline;
          }
        }
      }

      .card-course-description {
        font-size: 14px;
        font-weight: 400;
        line-height: 20px;
        margin-bottom: 4px;
      }

      .card-course-body {
        font-size: 14px;
        font-weight: 400;
        line-height: 20px;
        color: ${colorsV2.black80};
      }
    }

    ${fromScreen(458)} {
      .card-course {
        width: 343px;
      }
    }

    ${fromScreen(776)} {
      .card-course {
        width: auto;
      }
      grid-auto-flow: unset !important;
      grid-template-columns: ${props =>
        props.isOtherCourse
          ? 'repeat(auto-fit, minmax(200px, 1fr))'
          : 'repeat(2, 1fr)'};
    }
  }
  ${fromScreen(1144)} {
    && {
      .course-group-list {
        grid-template-columns: ${props =>
          !props.isOtherCourse && 'repeat(4, 1fr)'};
      }
    }

    ${props =>
      props.isOtherCourse &&
      css`
        margin-top: -200px;
        background: #ffffff;
        padding: 32px !important;
        border-radius: 20px;
        box-shadow: 0px 10px 20px 0px #0000000a;
      `}

    .center {
      text-align: center;
    }
  }
`;

export const Course = ({ title, level, isOtherCourse, centerLevel }) => {
  const { courseWithTeachers } = useCoursesWithTeacher();
  const { desktopGroupCourses } = useCoursesGroupData();
  const sortedCourses = groupCoursesIeltsForDisplay(
    courseWithTeachers,
    desktopGroupCourses
  );

  return (
    <CourseListContainer isOtherCourse={isOtherCourse}>
      <Typography
        variant="bold/24-32"
        tabletVariant="bold/32-40"
        desktopVariant="bold/40-48"
        v3
        className={cl({ center: centerLevel })}
        as="h2"
      >
        {title}
      </Typography>
      <div className="course-list">
        <Grid
          gap="24px"
          className={cl('course-group-list', {
            'two-column': sortedCourses[level].length === 4
          })}
          columns="repeat(4, 1fr)"
          style={{
            overflow: 'auto',
            marginTop: '32px'
          }}
        >
          {sortedCourses &&
            sortedCourses[level].map(item => (
              <>
                {item.whatYouGets.length ? (
                  <CardCoursePopup
                    key={item.name + item.description}
                    courseItem={item}
                    moreInfo={false}
                  />
                ) : (
                  <CardCourse
                    key={item.name + item.description}
                    data={item}
                    moreInfo={false}
                  />
                )}
              </>
            ))}
        </Grid>
      </div>
    </CourseListContainer>
  );
};
